import { Api } from 'models/services/api';
import { UpdateOriginalDishCategoryQuery } from 'models/services/graphql';

import { OriginalDishCategoryData, OriginalDishCategoryDataToSave } from '../index';

type DataToUpdate = {
  id: string;
  input: OriginalDishCategoryDataToSave;
};

const RequestQuery = `
  mutation UpdateOriginalDishCategory($id: ID!, $input: OriginalDishCategoryInput!) {
    ${UpdateOriginalDishCategoryQuery}
  }
`;

type ResponseData = {
  data: {
    updateOriginalDishCategory: OriginalDishCategoryData
  }
}

class UpdateGql {

  readonly api: Api<ResponseData>;
  readonly document?: OriginalDishCategoryData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToUpdate): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.updateOriginalDishCategory;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { UpdateGql };